/**
 * 状态的派生属性
 */

/**
 * 获取问题列表
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const getQuestList = state => {
  return state.quest.list;
};

/**
 * 获取地区列表
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const getAreaList = state => {
  return state.area.list;
};

/**
 * 获取补充资料选项
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const getAddOptions = state => {
  return state.addOptions;
};

/**
 * 获取账号修复选项
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const getRepairOptions = state => {
  return state.repairOptions;
};

/**
 * 获取当前操作步骤
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const getCurProcess = state => {
  return state.curProcess;
};

/**
 * 获取申请结果
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const getApplyResult = state => {
  return state.applyResult;
};

/**
 * 获取补充结果
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const getAddResult = state => {
  return state.addResult;
};

/**
 * 获取查询结果
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const getQueryResult = state => {
  return state.queryResult;
};

/**
 * 获取邮件发送状态
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const getEmailSendStatus = state => {
  return state.emailSendStatus;
};

/**
 * 获取重置密码状态
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const getResetPwdStatus = state => {
  return state.resetPwdStatus;
};

/**
 * 获取重置邮箱状态
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const getResetEmailStatus = state => {
  return state.resetEmailStatus;
};

/**
 * 获取重置安全问题
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const getResetQuestStatus = state => {
  return state.resetQuestStatus;
};

/**
 * 获取弹窗状态
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const getDialogs = state => {
  return state.dialogs;
};
